import WithRender from "../../templates/base/preflightInfo.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([]),
    isStatus: function () {
      return this.propsData.isStatus ? this.propsData.isStatus : false;
    },
    valid: function () {
      return this.propsData.valid;
    },
    label: function () {
      return this.propsData.label + ":";
    },
    message: function () {
      return this.propsData.message;
    },
    name: function () {
      return this.propsData.name;
    }
  },
  methods: {
    ...mapActions([""])
  },
  props: ["propsData"]
});
